<template>
  <section>
    <span
      class="text-weight-bolder"
      style="display: block; font-size: 16px; color: #21324a"
      >Participações em Treinamentos</span
    >
    <q-table
      style="max-height: 500px"
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :loading="disable"
      :columns="columns"
      no-data-label="Nenhuma participação encontrada."
      v-model:pagination="pagination"
      class="tabela-tamanho-fixo my-sticky-header-table"
      color="primary"
      dense
      row-key="name"
      @request="handleRequest"
      :rows-per-page-label="'Linhas Por Página'"
      :rows-per-page-options="[10, 25, 50, 100]"
    >
      <template v-slot:top-left>
        <span style="display: block; margin-left: -15px; color: #21324a"
          >Treinamentos já consolidado pelo usuário.</span
        >
      </template>
      <template v-slot:top-right>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filtrar"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template #body-cell-autenticacao="props">
        <q-td>
          <q-img
            :src="props.row.capacitacao_auth_content"
            style="max-width: 60px; height: 60px"
            fit="contain"
          >
          </q-img>
        </q-td>
      </template>
      <template #body-cell-treinamento_data_realizacao="props">
        <q-td>
          <span v-if="props.row.treinamento_data_realizacao">{{
            props.row.treinamento_data_realizacao.split("-").reverse().join("/")
          }}</span>
        </q-td>
      </template>
      <template #body-cell-treinamento_data_expiracao="props">
        <q-td>
          <span v-if="props.row.treinamento_data_expiracao">{{
            props.row.treinamento_data_expiracao.split("-").reverse().join("/")
          }}</span>
        </q-td>
      </template>
      <template #body-cell-capacitacao_data_confirmacao="props">
        <q-td>
          <span v-if="props.row.capacitacao_data_confirmacao">{{
            props.row.capacitacao_data_confirmacao
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("/")
          }}</span>
          <span class="q-ml-sm" v-if="props.row.capacitacao_data_confirmacao">{{
            props.row.capacitacao_data_confirmacao.split(" ")[1]
          }}</span>
        </q-td>
      </template>
    </q-table>
  </section>
</template>

<script setup>
import { ref, onMounted, computed, watch, defineProps } from "vue";
import { useStore } from "vuex";

import { useQuasar } from "quasar";

const props = defineProps({
  id: {
    type: Number,
  },
});

const userId = computed(() => props.id);

const columns = [
  {
    name: "treinamento_nome",
    label: "Treinamento",
    field: "treinamento_nome",
    align: "left",
  },
  {
    name: "treinamento_data_realizacao",
    label: "Realização",
    field: "treinamento_data_realizacao",
    align: "left",
  },
  {
    name: "capacitacao_instrutor",
    label: "Instrutor",
    field: "capacitacao_instrutor",
    align: "left",
  },
  {
    name: "treinamento_data_expiracao",
    label: "Vencimento",
    field: "treinamento_data_expiracao",
    align: "left",
  },
  {
    name: "capacitacao_data_confirmacao",
    label: "Confirmação",
    field: "capacitacao_data_confirmacao",
    align: "left",
  },
  {
    name: "autenticacao",
    label: "Autenticação",
    field: "autenticacao",
    align: "left",
  },
];

const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 10,
  // rowsNumber: 15,
});
const rows = ref([]);
const disable = ref(true);
const store = useStore();

const quasar = useQuasar();
const filtrar = ref("");

const getTreinamentos = async (page = 0, rowsPerPage = 15) => {
  disable.value = true;

  try {
    let response = await store.dispatch("user/getTreinamentos", {
      id: userId.value,
      page,
      treinamento: filtrar.value,
      per_page: rowsPerPage,
    });

    rows.value = response.data.data;

    pagination.value.page = response.data.current_page;
    pagination.value.rowsPerPage = response.data.per_page;
    pagination.value.rowsNumber = response.data.total;

    disable.value = false;
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro a o procurar dados",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const handleRequest = async (props) => {
  getTreinamentos(props.pagination.page, props.pagination.rowsPerPage);
};

onMounted(getTreinamentos);

watch(
  () => filtrar.value,
  () => {
    getTreinamentos();
  }
);
</script>
<style lang="sass">
.my-sticky-header-table
  /* height or max-height is important */
  max-height: 500px


  thead tr:first-child th
    /* bg color is important for th; just specify one */
    background-color: #EEF3FE

  thead tr th
    position: sticky
    z-index: 1
  thead tr:first-child th
    top: 0

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th
    /* height of all previous header rows */
    top: 48px

  /* prevent scrolling behind sticky top row on focus */
  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>
